import { useState, useEffect } from 'react';
import { getReviews } from '../services/api';

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterRating, setFilterRating] = useState('all');

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try { setReviews(await getReviews()); } catch (e) {}
    setLoading(false);
  };

  const filtered = reviews.filter(r => {
    const matchRating = filterRating === 'all' || String(Math.floor(r.rating)) === filterRating;
    const q = search.toLowerCase();
    const matchSearch = !q ||
      (r.customer_name || '').toLowerCase().includes(q) ||
      (r.worker_name || '').toLowerCase().includes(q) ||
      (r.service_name || '').toLowerCase().includes(q) ||
      (r.comment || '').toLowerCase().includes(q);
    return matchRating && matchSearch;
  });

  const avgRating = reviews.length ? (reviews.reduce((s, r) => s + r.rating, 0) / reviews.length).toFixed(2) : '0.00';
  const stars = (rating) => '⭐'.repeat(Math.round(rating)) + '☆'.repeat(5 - Math.round(rating));

  return (
    <div>
      <div className="page-header">
        <h1>⭐ Reviews</h1>
        <p>All customer reviews and ratings</p>
      </div>

      {/* Summary */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 24 }}>
        {[
          { label: 'Total Reviews', value: reviews.length, icon: '📝', color: '#1565c0', bg: '#e3f2fd' },
          { label: 'Average Rating', value: `${avgRating} ⭐`, icon: '⭐', color: '#f57f17', bg: '#fff8e1' },
          { label: '5 Star Reviews', value: reviews.filter(r => r.rating === 5).length, icon: '🌟', color: '#2e7d32', bg: '#e8f5e9' },
          { label: 'Low Ratings (≤2)', value: reviews.filter(r => r.rating <= 2).length, icon: '⚠️', color: '#c62828', bg: '#ffebee' },
        ].map(c => (
          <div key={c.label} style={{ background: c.bg, border: `1px solid ${c.color}22`, borderRadius: 12, padding: '16px 20px' }}>
            <div style={{ fontSize: 24 }}>{c.icon}</div>
            <div style={{ fontSize: 22, fontWeight: 700, color: c.color, marginTop: 4 }}>{c.value}</div>
            <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>{c.label}</div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <h2>All Reviews ({filtered.length})</h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              placeholder="🔍 Search customer, worker, service..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ padding: '6px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13, width: 260 }}
            />
            <select value={filterRating} onChange={e => setFilterRating(e.target.value)}
              style={{ padding: '6px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 13 }}>
              <option value="all">All Ratings</option>
              <option value="5">5 Star</option>
              <option value="4">4 Star</option>
              <option value="3">3 Star</option>
              <option value="2">2 Star</option>
              <option value="1">1 Star</option>
            </select>
            <button className="refresh-btn" onClick={load}>🔄 Refresh</button>
          </div>
        </div>

        {loading ? <div className="loading">Loading reviews...</div> : filtered.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#999', padding: 32 }}>No reviews found</p>
        ) : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Booking</th>
                  <th>Customer</th>
                  <th>Worker</th>
                  <th>Service</th>
                  <th>Rating</th>
                  <th>Comment</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(r => (
                  <tr key={r.id}>
                    <td>{r.id}</td>
                    <td>#{r.booking_id}</td>
                    <td>{r.customer_name || `User #${r.customer_id}`}</td>
                    <td>{r.worker_name || `Worker #${r.worker_id}`}</td>
                    <td>{r.service_name || '—'}</td>
                    <td>
                      <div style={{ color: '#f57f17', fontSize: 16 }}>{stars(r.rating)}</div>
                      <div style={{ fontSize: 12, color: '#666' }}>{Number(r.rating).toFixed(1)}</div>
                    </td>
                    <td style={{ maxWidth: 200, color: '#555', fontSize: 13 }}>
                      {r.comment || <span style={{ color: '#ccc' }}>No comment</span>}
                    </td>
                    <td style={{ fontSize: 12, color: '#666' }}>{r.created_at?.substring(0, 10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
